import React from 'react';
import { isCSR } from '../../../utils';
import { ArrowDownIcon, CompareIcon, CopyIban, CryptoIcon, DepositGuaranteeIcon, EtfConfiguratorIcon, EtfRoboIcon, EtfRurupIcon, FixedDepositIcon, HamburgerCloseIcon, HamburgerIcon, InfoIcon, InvestmentIcon, MoneyIcon, OvernightMoneyIcon, OverviewIcon, PagesIcon, PartnerIcon, PercentIcon, PrivateEquityIcon, RetirementProvisionIcon, SavingIcon, TaxIcon, TerminationPaymentIcon, TrendingUpIcon, } from '../Icons';
const ICON_COLLECTION = {
    overnightMoneyIcon: OvernightMoneyIcon,
    overviewIcon: OverviewIcon,
    taxIcon: TaxIcon,
    savingIcon: SavingIcon,
    etfRurupIcon: EtfRurupIcon,
    privateEquityIcon: PrivateEquityIcon,
    terminationPaymentIcon: TerminationPaymentIcon,
    trendingUpIcon: TrendingUpIcon,
    investmentIcon: InvestmentIcon,
    fixedDepositIcon: FixedDepositIcon,
    depositGuaranteeIcon: DepositGuaranteeIcon,
    etfRoboIcon: EtfRoboIcon,
    etfConfiguratorIcon: EtfConfiguratorIcon,
    cryptoIcon: CryptoIcon,
    retirementProvisionIcon: RetirementProvisionIcon,
    pagesIcon: PagesIcon,
    percentIcon: PercentIcon,
    partnerIcon: PartnerIcon,
    moneyIcon: MoneyIcon,
    compareIcon: CompareIcon,
    infoIcon: InfoIcon,
    ArrowDownIcon: ArrowDownIcon,
    CopyIban: CopyIban,
    HamburgerCloseIcon: HamburgerCloseIcon,
    HamburgerIcon: HamburgerIcon,
};
export const getIcon = (iconAlias) => {
    if (typeof iconAlias === 'undefined' || !ICON_COLLECTION[iconAlias]) {
        return null;
    }
    const IconComponent = ICON_COLLECTION[iconAlias];
    return React.createElement(IconComponent, null);
};
export const stringAvatar = (name) => {
    if (typeof name === 'undefined') {
        return undefined;
    }
    const nameArray = name.split(' ');
    return `${nameArray[0][0]}${nameArray.slice(-1)[0][0]}`;
};
export const copyHandler = (text) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
    }
};
export const isActiveMenu = (href = '') => {
    if (isCSR()) {
        const pathname = window.location.pathname;
        const hash = window.location.hash;
        return `${pathname}${hash}`.toLowerCase() === href.toLowerCase();
    }
    return false;
};
export const getActiveStatus = (subMenus, href) => {
    if (!subMenus)
        return isActiveMenu(href);
    const items = Object.values(subMenus).reduce((accumulator, currentValue) => [
        ...accumulator,
        ...(Array.isArray(currentValue) ? currentValue : []),
    ], []);
    return items.some((item) => isActiveMenu(item === null || item === void 0 ? void 0 : item.href));
};
export const isHrefCorrect = (href = '') => Boolean(href) && !/^\s*(javascript|data|vbscript):/i.test(href);
export const isTablet = () => {
    if (!isCSR()) {
        return false;
    }
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
};
//# sourceMappingURL=index.js.map